module.exports = __webpack_public_path__ + "static/media/oval-shape-locket-print.1d386a43.png";